import logEvent from '../../logEvent';

function logEventAssistedDigitalAccess(code, data) {
  logEvent(`UFACTVN-${code}`, data);
}

export function logEventAssistedDigitalAccessTriage1(data) {
  logEventAssistedDigitalAccess('01', data);
}

export function logEventAssistedDigitalAccessTriage2(data) {
  logEventAssistedDigitalAccess('02', data);
}

export function logEventAssistedDigitalAccessExistingUser() {
  logEventAssistedDigitalAccess('03');
}

export function logEventAssistedDigitalAccessWelcome() {
  logEventAssistedDigitalAccess('04');
}

export function logEventAssistedDigitalAccessCreateAccount(data) {
  logEventAssistedDigitalAccess('05', data);
}

export function logEventAssistedDigitalAccessEmailVerification() {
  logEventAssistedDigitalAccess('06');
}

export function logEventAssistedDigitalAccessIdvStart() {
  logEventAssistedDigitalAccess('07');
}

export function logEventAssistedDigitalAccessIdvSuccess(verificationJob) {
  const { id } = verificationJob || {};
  logEventAssistedDigitalAccess('08', { jobId: id });
}

export function logEventAssistedDigitalAccessIdvConfirmDetails(data) {
  logEventAssistedDigitalAccess('09', data);
}

export function logEventAssistedDigitalAccessManualId(data) {
  logEventAssistedDigitalAccess('10', data);
}

export function logEventAssistedDigitalAccessPersonalInfo(data) {
  logEventAssistedDigitalAccess('11', data);
}

export function logEventAssistedDigitalAccessSIN() {
  logEventAssistedDigitalAccess('12');
}

export function logEventAssistedDigitalAccessProfileNotFound() {
  logEventAssistedDigitalAccess('13');
}

export function logEventAssistedDigitalAccessEmploymentStatus(data) {
  logEventAssistedDigitalAccess('14', data);
}

export function logEventAssistedDigitalAccessMaritalStatus(data) {
  logEventAssistedDigitalAccess('15', data);
}

export function logEventAssistedDigitalAccessAnnualIncome(data) {
  logEventAssistedDigitalAccess('16', data);
}

export function logEventAssistedDigitalAccessAssetsLiabilities(data) {
  logEventAssistedDigitalAccess('17', data);
}

export function logEventAssistedDigitalAccessNumDependents(data) {
  logEventAssistedDigitalAccess('18', data);
}

export function logEventAssistedDigitalAccessInvExperience(data) {
  logEventAssistedDigitalAccess('19', data);
}

export function logEventAssistedDigitalAccessGoToDashboard() {
  logEventAssistedDigitalAccess('20');
}
